import React, {useRef, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import tsLogo from "../../assets/images/TS-Logo.png";
import axios from "axios";
import toast, {Toaster} from "react-hot-toast";
import Button from "react-bootstrap-button-loader";
import "./LoginPage.css";

const Login = () => {
  const passwordInput = useRef(null);

  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("TS_GEN_TOKEN");
  const appVersion = localStorage.getItem("APP_VERSION");

  let navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [passWord, setPassWord] = useState("");
  const [rememberMe, setIsRememberMe] = useState(false);

  const [buttonLoader, setButtonLoader] = useState(false);

  // user login - function
  const userLogin = () => {
    setButtonLoader(true);

    axios({
      method: "POST",
      url: `${baseUrl}/user/login`,
      headers: {
        Authorization: token,
      },
      data: {
        username: email,
        password: passWord,
        rememberMe: rememberMe,
      },
    })
      .then((response) => {
        let data = response.data.data;
        setButtonLoader(false);
        configurationData();
        toast.remove();
        // toast.success('User successfully login!', {
        //     position: 'bottom-center',
        // });

        const userToken = "Bearer " + data.token;

        localStorage.setItem("user_token", userToken);
        delete data.token;
        localStorage.setItem("user_details", JSON.stringify(data));
        // history.push('/landing-page')
        // navigate("/home");
        navigate("/feedback-dashboard");
      })
      .catch((error) => {
        console.log(error);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
          setButtonLoader(false);
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
          setButtonLoader(false);
        }
      });
  };

  const configurationData = () => {
    setButtonLoader(true);
    axios({
      method: "POST",
      url: `${baseUrl}/branch/get-configs`,
      headers: {
        Authorization: token,
      },
      data: {
        response: [
          "mq-password",
          "mqtt",
          "web-socket",
          "mq-username",
          "ip",
          "port",
          "use-ssl",
        ],
      },
    }).then((res) => {
      setButtonLoader(false);

      let data = res.data.data;

      //  !!!!! read before edit this !!!!!

      //we can simply set the whole object to the local storage like this.
      localStorage.setItem("configuration_data", JSON.stringify(data));

      //Also I did this. Looks like below part is not nessessory. But there is a reason for this.
      //If you remove below code lines, then the notification part will not work. Why? because somehow-
      //-I can't get the values from the 'configuration_data'(Local storage) object in 'Header.js' component. Why is that.?
      //Good question. I don't no. But you can find a solution for that. Until that, please do not remove below code lines.
    });
  };

  return (
    <>
        <Toaster/>
        <div className="login-page">
            <div className="login-page__background">
                <div className="login-page__gradient"></div>
                <span className="login-page__orb login-page__orb--one"></span>
                <span className="login-page__orb login-page__orb--two"></span>
                <span className="login-page__orb login-page__orb--three"></span>
                {/* <div className="login-page__glow"></div> */}
            </div>

            <div style={{opacity: 0.9}} className="login-page__card">
                <div className="login-page__brand">
                    <Link className="login-page__brand-link" to="/">
              <img
                src={tsLogo}
                width="92"
                height="92" 
                alt="Ts logo"
              />
            </Link>
          </div>

                <div className="login-page__body">
                    <h1 className="login-page__title text-warning">Welcome back</h1>
                    <p className="login-page__subtitle">Please enter your details</p>

                    <form
                        className="login-page__form"
                        method={"POST"}
                        action="/"
                    >
                        <div className="login-page__field">
                            <label htmlFor="signin-email" className="login-page__label">
                                Email
                            </label>
                            <input
                                type="email"
                                className="login-page__input"
                                id="signin-email"
                                value={email}
                                placeholder="name@company.com"
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                }}
                                onKeyUp={(e) => {
                                    if (e.key === "Enter") {
                                        passwordInput.current.focus();
                                    }
                                }}
                            />
                        </div>

                        <div className="login-page__field">
                            <label htmlFor="signin-password" className="login-page__label">
                                Password
                            </label>
                            <input
                                type="password"
                                className="login-page__input"
                                id="signin-password"
                                ref={passwordInput}
                                value={passWord}
                                placeholder="Your password"
                                onChange={(e) => {
                                    setPassWord(e.target.value);
                                }}
                                onKeyUp={(e) => {
                                    if (e.key === "Enter") {
                                        userLogin();
                                    }
                                }}
                            />
                        </div>

                        <div className="login-page__actions">
                            <label className="login-page__remember">
                                <input
                                    type="checkbox"
                                    value={rememberMe}
                                    onChange={(e) => {
                                        setIsRememberMe(true);
                                    }}
                                />
                                <span>Keep me signed in</span>
                            </label>
                            <Link to="/forgotpassword" className="login-page__link">
                                Forgot password?
                            </Link>
                        </div>

                        <Button
                            loading={buttonLoader}
                            className="login-page__submit"
                            onClick={() => {
                                userLogin();
                            }}
                        >
                            Sign in
                        </Button>
                    </form>

                    <div className="login-page__footer">
                        <span>Don't have an account?</span>
                        <Link to="/register" className="login-page__link">
                            Create one
                        </Link>
            </div>
          </div>
        </div>

            <label className="login-page__version">
                {localStorage.getItem("APP_VERSION") !== undefined ? (
            <>Version {localStorage.getItem("APP_VERSION")}</>
          ) : null}
        </label>
      </div>
    </>
  );
};

export default Login;
